var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24902 5.33286L6.70797 2.4342C6.87666 2.1 7.28472 1.96587 7.61754 2.1341C7.74748 2.20003 7.85234 2.30688 7.91845 2.43875L9.29762 5.2351C9.40932 5.46472 9.63045 5.61931 9.88348 5.64887L12.7672 5.99443C13.1593 6.04217 13.4397 6.39911 13.3941 6.79242C13.3736 6.95383 13.3006 7.10388 13.1844 7.21755L10.9025 9.46145C10.809 9.55239 10.7657 9.67971 10.7817 9.80929L11.1624 12.8375C11.2171 13.2718 10.9093 13.6674 10.4762 13.7219C10.3121 13.7424 10.1479 13.7128 10.002 13.6332L7.59247 12.3192C7.41693 12.2237 7.20721 12.2214 7.03168 12.3124L4.53321 13.5901C4.18215 13.7697 3.75358 13.6287 3.57349 13.2763C3.50511 13.1445 3.48231 12.9967 3.50283 12.8512L3.70115 11.4598C3.79918 10.7801 4.22091 10.189 4.83184 9.8775L7.60386 8.46568C7.67681 8.4293 7.70645 8.33837 7.66997 8.26334C7.64034 8.20651 7.57879 8.1724 7.51496 8.1815L4.12288 8.66802C3.60541 8.74077 3.0811 8.59527 2.67304 8.26334L1.54463 7.34487C1.2232 7.08342 1.17077 6.60599 1.43293 6.28316C1.55603 6.13311 1.73156 6.03535 1.92305 6.01035L4.81817 5.63977C5.00282 5.61476 5.16467 5.50109 5.24902 5.33286Z",
    fill: "url(#paint0_linear_476_2371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_2371",
    x1: 9.99902,
    y1: 2.00073,
    x2: 16.2888,
    y2: 6.94373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E57C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTgStar);
export default __webpack_public_path__ + "static/media/icon-tg-star.eccc526f3d88cdabc9284444a24fb0ff.svg";
export { ForwardRef as ReactComponent };